import { render, staticRenderFns } from "./informationDetail.vue?vue&type=template&id=51d6a792&scoped=true&"
import script from "./informationDetail.vue?vue&type=script&lang=js&"
export * from "./informationDetail.vue?vue&type=script&lang=js&"
import style0 from "./css/index.css?vue&type=style&index=0&id=51d6a792&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51d6a792",
  null
  
)

export default component.exports